/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_Domain_SearchInputs */

const id_portal_nav_domain_search = /** @type {(inputs: Portal_Nav_Domain_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari domain`)
};

const en_portal_nav_domain_search = /** @type {(inputs: Portal_Nav_Domain_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search domains`)
};

/**
* | output |
* | --- |
* | "Search domains" |
*
* @param {Portal_Nav_Domain_SearchInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_nav_domain_search = /** @type {((inputs?: Portal_Nav_Domain_SearchInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_Domain_SearchInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_nav_domain_search(inputs)
	return id_portal_nav_domain_search(inputs)
});